<template>
    <div v-show="getCompanyDetail.data" >
        <company-detail-header page-name="法人詳細"></company-detail-header>
        <div class="container">
            <!-- Nav tabs -->
            <ul class="nav nav-tabs tab-sticky breadcrumb p-0 mb-1 nav-justified" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active text-center px-2" data-toggle="tab" href="#company">会社情報</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-center px-2" data-toggle="tab" href="#member"></i>メンバー情報</a>
                </li>
            </ul>
            <div class="tab-content">
                <div id="company" class="container tab-pane active p-0">
                    <!-- 会社情報 -->
                    <company-tab></company-tab>
                </div>

                <div id="member" class="container tab-pane fade p-0">
                    <!-- 応募者 -->
                    <member-tab></member-tab>
                </div>
            </div>
        </div>

        <!-- メンバー設定 -->
        <member-set ref="set"></member-set>

        <!-- メッセージ -->
        <info-msg ref="msg" :lev="lev" :msg="msg" @ok="msgOk"></info-msg>
    </div>
</template>

<script>
    import CompanyDetailHeader from 'pages/commons/header/Header'
    import CompanyTab from './components/CompanyTab'
    import MemberTab from './components/MemberTab'
    import InfoMsg from 'pages/commons/modal/infoMsg/InfoMsg'
    import MemberSet from './components/Set'
    import {mapGetters} from 'vuex'

    export default {
        created () {
            this.loadCompanyDetail()
        },
        destroyed () {
            this.$store.dispatch('resetCompanyDetail')
        },
        components: {
            CompanyDetailHeader,
            CompanyTab,
            MemberTab,
            MemberSet,
            InfoMsg,
        },
        data () {
            return {
                msg: "",
                lev: 0,
                msgKey: "",
                selectId: "",
                deleted: false
            }
        },
        watch: {
            getCompanyDetailLoadStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startProgress')
                }
                if (status == 2) {
                    this.$store.dispatch('doneProgress')
                }
                if (status == 3) {
                    this.$store.dispatch('doneProgress')
                }
            },
        },
        computed: {
            ...mapGetters(['getCompanyDetail', 'getCompanyDetailLoadStatus', 'getDelCompanyStatus'])
        },
        methods: {
            loadCompanyDetail () {
                this.$store.dispatch('loadCompanyDetail',
                    this.$route.params.group
                )
            },
            openSet (can, cnt, id, group) {
                this.$refs.set.openThis(can, cnt, id, group)
            },
            openMsg (lev, msg, key="", id="") {
                this.lev = lev
                this.msg = msg
                this.msgKey = key
                this.selectId = id
                this.$refs.msg.openThis()
            },
            msgOk () {
                if (this.msgKey == 'deleteCompany') {
                    this.$store.dispatch('delCompany', {
                        group: this.selectId,
                    })
                }
            },
        }
    }
</script>

<style lang="stylus" scoped>
.tab-sticky
    position:sticky!important
    top:122px!important
    z-index:98
</style>
